module.exports = __webpack_public_path__ + "static/media/1. Setup demo wiki channels.03cd32d3.svg";